var render, staticRenderFns
import script from "./AnnouncementsIndex.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/classleasingtraffic.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1f5298')) {
      api.createRecord('2d1f5298', component.options)
    } else {
      api.reload('2d1f5298', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/Backend/AnnouncementsIndex.vue"
export default component.exports